export interface IRecipientSearchRequest{
    show: number,
    status: number
    alias: string
}